import { useCallback, useMemo } from 'react';
import { IN } from 'framework-listing-lib/utils/filters';
import { useListingLibQuickFilters } from 'framework-listing-lib/hooks/useQuickFilters';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { PROPERTIES } from '../constants';
const property = PROPERTIES.FORM_TYPE;
const useFormTypeFilter = () => {
  const {
    getQuickFilterValue,
    removeQuickFilter,
    setQuickFilter
  } = useListingLibQuickFilters();
  const currentValue = getQuickFilterValue(property);
  const active = useMemo(() => currentValue != null, [currentValue]);
  const handleChange = useCallback(event => {
    const {
      value
    } = event.target;
    if (!value || !value.length) {
      removeQuickFilter(property);
    } else {
      setQuickFilter(IN(property, value));
    }
    trackDashboardInteraction('filter-objects-by-form-type', {
      formTypes: value || []
    });
  }, [removeQuickFilter, setQuickFilter]);
  const handleClearFilter = useCallback(() => {
    removeQuickFilter(property);
    trackDashboardInteraction('filter-objects-by-form-type', {
      formTypes: []
    });
  }, [removeQuickFilter]);
  return useMemo(() => ({
    currentValue,
    active,
    handleChange,
    handleClearFilter
  }), [active, currentValue, handleChange, handleClearFilter]);
};
export default useFormTypeFilter;